import {createFileRoute} from '@tanstack/react-router';

import {ApprovalChainsPage} from '@/modules/settings/pages/ApprovalChainsPage';

export const Route = createFileRoute('/_authenticated/admin/approval-chains/')({
  component: ApprovalChainsPage,
});
